"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseStatus = void 0;
var ResponseStatus;
(function (ResponseStatus) {
    ResponseStatus["ACCEPTED"] = "accepted";
    ResponseStatus["REJECTED"] = "rejected";
})(ResponseStatus || (exports.ResponseStatus = ResponseStatus = {}));
